import type { Submission } from "@/lib/api";

/**
 * Where a submission's page is.
 *
 * A server-simulated run's page is its session's -- the attempt, of which the submission
 * is one field -- so a link from a leaderboard row or a "your best" tile goes there
 * directly rather than bouncing off the submission route's redirect.
 */
export function submissionHref(
  challengeId: string,
  submission: Pick<Submission, "job_id" | "session_id">,
): string {
  return submission.session_id
    ? attemptHref(challengeId, submission.session_id)
    : `/challenges/${challengeId}/submissions/${submission.job_id}`;
}

export function attemptHref(challengeId: string, sessionId: string): string {
  return `/challenges/${challengeId}/attempts/${sessionId}`;
}
